import { getTablePresets } from '../services';
export const fetchTablePresets = () => getTablePresets().then(response => formattedTablePresets(response));
const formattedTablePresets = ({ data }) => {
    const result = data.presets;
    return result;
};
